import {
  V2ListServiceConditionsForAccountApiArg,
  useV2ListServiceConditionsForAccountQuery,
} from "@generated";
import type { ServiceCondition } from "../types";

export interface UseServiceConditionsListArgs {
  page?: V2ListServiceConditionsForAccountApiArg["page"];
  filter?: V2ListServiceConditionsForAccountApiArg["filter"];
}

export interface ServiceConditionsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useServiceConditionsList = ({
  page,
  filter,
}: UseServiceConditionsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListServiceConditionsForAccountQuery(
      { page, filter },
      { refetchOnMountOrArgChange: true }
    );

  const rows: ServiceCondition[] = (data?.data ?? [])
    .map((sc: any) => ({
      id: String(sc.id),
      name: sc.attributes?.name ?? "",
      status: (sc.attributes?.status ?? "required") as "required" | "optional",
      position: sc.attributes?.position ?? 0,
    }))
    .sort((a, b) => a.position - b.position);

  const pageMeta: ServiceConditionsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useServiceConditionsList;
